export default function SoftwareDev() {
  return (
    <div style={{ padding: '150px 10%' }}>
      <h1>Software <span className="blue-glow-text">Development</span></h1>
      <p>Custom Application Development starting from 5000 QAR. UI/UX & Lead Generation systems.</p>
      <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085" alt="Code" style={{ width: '100%', borderRadius: '20px' }} />
    </div>
  );
}